import EventBus from 'event_bus'

export default class BookmarkListEmpty {
  constructor ($el) {
    this.onBookmarkEmpty = this.onBookmarkEmpty.bind(this)
    this.onBookmarkAdded = this.onBookmarkAdded.bind(this)
    this.$el = $el
    this.addEventListeners()
  }

  addEventListeners () {
    EventBus.on('bookmarks:empty', this.onBookmarkEmpty)
    EventBus.on('bookmarks:added', this.onBookmarkAdded)
  }

  removeEventListeners () {
    return EventBus.off('bookmarks:empty', this.onBookmarkEmpty)
  }

  onBookmarkEmpty (_event) {
    return this.$el.fadeIn()
  }

  onBookmarkAdded (_event) {
    this.$el.fadeOut()
  }
}
